<template>
  <div class="main">
    <heads></heads>
    <navs></navs>
    <banners></banners>
    <div class="content">
      <div class="con-main">
        <div class="con-left">
          <div class="con-left-title">
            <div class="con-left-title-btn">
              <el-button type="primary" size="small" @click="fanhui"
                >返回</el-button
              >
              <!-- 健康人报 不显示期数 20231010 -->
              <el-button type="success" size="small" @click="comeback"
                >查看本期</el-button
              >
              <el-button type="warning" size="small" @click="dVisible=true">证书下载</el-button>
            </div>
          </div>
          <div class="con-left-xq">
            <div class="con-left-xq-title">{{ newdetail.title }}</div>
            <div class="con-left-xq-subtitle">
              <span>{{ newdetail.org }}</span>
              <span>{{ newdetail.writer }}</span>
              <span>浏览量：{{ newdetail.readnum }}</span>
            </div>
            <div class="con-left-xq-nr">
              <div class="con-left-xq-nr-zy" v-if="newdetail.zy && newdetail.zy!=''">
                <b>摘要：</b>{{ newdetail.zy }}
              </div>
              <div class="con-left-xq-nr-zw" v-html="newdetail.zw"></div>
              <!-- 健康人报 不显示期数 20231010 -->
              <div class="con-left-xq-nr-ly">{{newdetail.bsname}}-{{newdetail.qsname?newdetail.qsname[0]:''}}年{{newdetail.qsname?newdetail.qsname[1]:''}}月（总第{{newdetail.zqs}}期）-第{{newdetail.sybm?newdetail.sybm[0]:''}}版</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <zhengshuxiazai :dVisible="dVisible"  @clickClose="clickClose"></zhengshuxiazai>
    <footers></footers>
  </div>
</template>

<style scoped>
::v-deep .el-carousel__container {
  height: 200px;
}
.main {
  background: #fff;
}
.con-main {
  width: 1200px;
  margin: auto;
  margin-bottom: 30px;
}
.con-main:after {
  content: "";
  display: table;
  clear: both;
}
a:link,
a:visited {
  text-decoration: none;
  color: #333;
}
a:hover {
  color: #777;
}
.con-left {
  width: 100%;
  height: auto;
  float: left;
  padding-bottom: 50px;
}

.con-left-title {
  border-bottom: 1px solid #ccc;
  font-weight: bold;
  padding: 20px 0 10px 0;
  box-sizing: border-box;
}
.con-left-title:after {
  content: "";
  display: table;
  clear: both;
}
.con-left-title-nav {
  float: left;
  height: 30px;
  line-height: 30px;
  margin-right: 10px;
  font-size: 14px;
}

.con-left-fy {
  padding: 30px 0;
}

.con-left-xq-title {
  text-align: center;
  font-size: 24px;
  padding: 30px 0 20px 0;
}
.con-left-xq-subtitle {
  text-align: center;
  color: #999;
  font-size: 14px;
  padding-bottom: 30px;
}
.con-left-xq-subtitle > span{
  padding: 0 10px;
}
.con-left-xq-nr {
  font-size: 14px;
  text-align: justify;
  line-height: 28px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 30px;
}
.con-left-xq-sxw {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.con-left-xq-sxw-pre {
  font-size: 14px;
  cursor: pointer;
}
.con-left-xq-sxw-pre:hover {
  color: #2fadc6;
}
.con-left-title-btn {
  display: flex;
  align-items: center;
  float: left;
}
.con-left-xq-nr-zy {
  text-indent: 28px;
}
.con-left-xq-nr-zw {
  text-indent: 28px;
}
.con-left-xq-nr-ly{
  text-align: right;
  padding: 10px 0 0 0;
  font-weight: bold;
  color: #999;
}
</style>

<script setup>
// vuex
import { useStore } from "vuex";
const store = useStore();
// router
import { useRouter } from "vue-router";
const router = useRouter();
import { get } from "@/utils/index";
import { reactive,ref } from "vue";
// 详情
let newdetail = reactive({});
// 显示对话框
let dVisible=ref(false)
// 关闭对话框
const clickClose=val=>{
  dVisible.value=val
}
// 获取详情
const getdetail = () => {
  get("/api/NewsPaper/GetArticle", {
    id: router.currentRoute.value.query.wzid,
  }).then((res) => {
    res.data.qsname=res.data.qsname.split("_")
    res.data.sybm=res.data.sybm.split(",")
    Object.assign(newdetail, res.data);
    // 页面标题描述摘要
    document.title = res.data.title;
    // document
    //   .querySelector('meta[name="keywords"]')
    //   .setAttribute("content", "");
    // document
    //   .querySelector('meta[name="description"]')
    //   .setAttribute("content", "");
  });
};
getdetail();

// 返回
const comeback = () => {
  // 需要根据导航的id判断path的取值
  let navpath = "";
  switch (newdetail.bztype) {
    case 1:
    navpath = "/jyyj";
    break;
  case 2:
    navpath = "/kjts";
    break;
  case 3:
    navpath = "/jkkp";
    break;
  case 4:
    navpath = "/szyt";
    break;
  case 5:
    navpath = "/myrh";
    break;
  case 6:
    navpath = "/xljj";
    break;
  case 7:
    navpath = "/xxfz";
    break;
  case 8:
    navpath = "/kjts";
    break;
  default:
    navpath = "";
    break;
  }
  router.push({
    path: navpath+'/index',
    query: {
      navid: newdetail.bztype, //大分类id
      id: newdetail.qsId, //当前期数id
      bzid: newdetail.bsId, //报纸id  用于获取全部期数
      bmidx: newdetail.sybm, //版面
      idx: newdetail.bztype+1, //导航索引  bztype+1=idx
    },
  });
};

// 返回
const fanhui=()=>{
  window.history.go(-1);
}
</script>
